import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
  username: Yup.string().email().required().label('Email'),
  password: Yup.string().required().label('Password'),
});
